import { Bar } from 'react-chartjs-2';
import LineChart from "../../../../content/posts/2020-01-23-gatsby-mdx-charts/LineChart.js";
import React from 'react';
export default {
  Bar,
  LineChart,
  React
};